<template>
  <main class="mb-10">
    <cms-section v-if="eSpots?.[0]" :section="eSpots?.[0]" />
    <div
      id="how-to-return"
      class="c-black"
      :style="{ scrollMarginTop: pxToRem(header.height.full) }"
    >
      <h1 class="mb-7 lg:mb-10 display-3">
        {{ headingTitle }}
      </h1>
      <h2 class="mb-3 mt-10 title-2">
        {{ returnProcess.heading }}
      </h2>
      <p v-html="returnProcess.description" class="mb-3 lh-2" />
      <vf-button size="xs" to="/order-status" variant="tertiary">
        {{ returnProcess.returnCta }}
      </vf-button>
      <h2 class="mb-3 mt-10 title-2">
        {{ returnOnlinePurchases.heading }}
      </h2>
      <p>
        <base-interpolator :content="returnOnlinePurchases.paragraph">
          <template #tnf-link="{ args: [message] }">
            <vf-link class="hover:c-brand-2" :to="originUrl">
              {{ message }}
            </vf-link>
          </template>
          <template #return-link="{ args: [message] }">
            <vf-link class="hover:c-brand-2" to="/order-status">
              {{ message }}
            </vf-link>
          </template>
        </base-interpolator>
      </p>
      <h2 class="mb-6 mt-10 lg:my-10 title-2">
        {{ returnSteps.heading }}
      </h2>
      <base-grid :cols="{ sm: 2, lg: 4 }" gap="sm">
        <base-link
          v-for="({ title, image }, key) in returnSteps.items"
          :key
          :to="`#step-${key + 1}`"
        >
          <div v-style:h="{ sm: '12rem', md: '10rem' }" class="f-col items-center b-t-5 b-t-transparent bg-grey-90 p-6 hover:b-brand-2 hover:c-brand-2">
            <base-picture v-bind="image" />
            <p class="mt-5 text-center fw-medium lh-none uppercase lg:text-sm">
              {{ title }}
            </p>
          </div>
        </base-link>
      </base-grid>
      <div
        v-for="({ title, description, steps, image }, key) in returnSteps.items"
        :key
        :id="`step-${key + 1}`"
        class="mt-10 space-y-4"
        :style="{ scrollMarginTop: pxToRem(header.height.full) }"
      >
        <p class="mb-3 flex items-center gap-2 fw-medium">
          <base-picture v-bind="image" height="25" width="25" />
          {{ title }}
        </p>
        <p v-html="description" class="lh-2" />
        <ol v-if="steps" class="list-decimal-inside">
          <li v-for="item in steps" :key="item">
            {{ item }}
          </li>
        </ol>
      </div>
      <cms-section v-if="eSpots?.[1]" class="mt-3" :section="eSpots?.[1]" />
      <div class="my-10">
        <vf-accordion
          v-for="({ title, descriptions }, key) in accordions"
          :key
          class-title="ws-normal"
          size="sm"
          :title
          variant="aligned"
        >
          <div class="pb-6 space-y-3">
            <div v-for="(description, i) in descriptions" :key="i">
              <base-interpolator :content="description">
                <template #my-account="{ args: [message] }">
                  <vf-link class="hover:c-brand-2" to="/account">
                    {{ message }}
                  </vf-link>
                </template>
                <template #return-link="{ args: [message] }">
                  <vf-link class="hover:c-brand-2" to="/order-status">
                    {{ message }}
                  </vf-link>
                </template>
                <template #how-to-return="{ args: [message] }">
                  <base-link class="underlined hover:c-brand-2" href="#how-to-return">
                    {{ message }}
                  </base-link>
                </template>
                <template #contact-us="{ args: [message] }">
                  <vf-link class="hover:c-brand-2" to="/help-section/contact-us">
                    {{ message }}
                  </vf-link>
                </template>
              </base-interpolator>
            </div>
          </div>
        </vf-accordion>
      </div>
      <p v-for="(text, key) in haveQuestionTexts" :key class="mb-2">
        <base-interpolator :content="text">
          <template #faq="{ args: [message] }">
            <vf-link class="hover:c-brand-2" to="/help-section/faq">
              {{ message }}
            </vf-link>
          </template>
          <template #contact-us="{ args: [message] }">
            <vf-link class="hover:c-brand-2" to="/help-section/contact-us">
              {{ message }}
            </vf-link>
          </template>
        </base-interpolator>
      </p>
    </div>
  </main>
</template>

<script lang="ts" setup>
const originUrl = useOrigin()
const { data, error } = await useApi().internal.getStaticPage('help/returns/how-to-return')
const eSpots = (await useCms().getSections.generic('how-to-return')).data.value?.content.sections

if (!data.value) throw createError({ ...error.value!, fatal: true })

const {
  headingTitle,
  returnProcess,
  returnOnlinePurchases,
  returnSteps,
  accordions,
  haveQuestionTexts
} = data.value

const header = useHeaderStore()
</script>
